import React from "react"
import Navigation from "../navigation"
import styles from "./futureheader.module.css"
import header from "./FutureofGovEd_611.png"

const FutureHeader = (props) => {

    return (
        <div className={styles.container}>
            <Navigation 
                type="horizontal"
                items={[
                    {
                        title: "Upcoming Sessions",
                        url: "/#events",
                    },
                    {
                        title: "On-Demand Sessions",
                        url: "/on-demand",
                    },
                    
                    
                ]}
            />
            <img src={header} alt="SNG Live Future of Government & Education" className="deskHead" width="100%"/>
            <img src={header} alt="SNG Live Future of Government & Education" className="mobHead" width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
                
            </div>
            
        </div>
    )
}

FutureHeader.defaultProps = {
    title: `SNG Live - Future of Government`,
    subTitle: `2020`
}
export default FutureHeader